import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import 'dotdotdot-js'

@Component({
  selector: 'app-announce-detail',
  templateUrl: './announce-detail.component.html',
  styleUrls: ['./announce-detail.component.scss']
})
export class AnnounceDetailComponent implements OnInit, AfterViewInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: MainService,
    private _sanitizer: DomSanitizer) { }

  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';

  id: any;

  private player;
  private ytEvent;

  announce: any;
  showAnnounce: any;
  detail: any;
  file_pdf: string;
  announceTitle: string;
  announceType: string;
  announceDate: string;
  pdfUrl_path: any;
  pdfUrl: any;
  test1: JQuery<HTMLElement>

  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.announce = this.route.params.subscribe(params => {
      this._mainService.getAnnounceByID(params['id']).subscribe(response => {
        
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].announce_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail = this.htmlTransforms(response[0].detail)
            this.detail = this.htmlTransforms(response[0].detail)

            this.showAnnounce = response
            this.announceTitle = response[0].title
            this.announceType = response[0].announce_type
            this.announceDate = this._mainService.date_thai(response[0].publicDate)

          } else if (response[0].announce_type === 'image') {
            this.file_pdf = 'no'
            this.showAnnounce = response
            this.detail = response[0].detail
            this.announceTitle = response[0].title
            this.announceType = response[0].announce_type
            this.announceDate = this._mainService.date_thai(response[0].publicDate)

          } else if (response[0].announce_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail
            this.showAnnounce = response
            this.pdfUrl = this.urlTransform(response[0].detail)
            this.announceTitle = response[0].title
            this.announceType = response[0].announce_type
            this.filesize = response[0].filesize
            this.announceDate = this._mainService.date_thai(response[0].publicDate)
          }
          else if (response[0].announce_type === 'vdo') {
            this.file_pdf = 'no'
            this.showAnnounce = response
            this.id = response[0].detail
            this.announceTitle = response[0].title
            this.announceType = response[0].announce_type
            this.announceDate = this._mainService.date_thai(response[0].publicDate)

          }
        } else {
          if (response[0].announce_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail_en = this.htmlTransforms(response[0].detail_en)
            this.detail = this.htmlTransforms(response[0].detail_en)

            this.showAnnounce = response
            this.announceTitle = response[0].title_en
            this.announceType = response[0].announce_type
            this.announceDate = response[0].publicDate;

          } else if (response[0].announce_type === 'image') {
            this.file_pdf = 'no'
            this.showAnnounce = response
            this.detail = response[0].detail_en
            this.announceTitle = response[0].title_en
            this.announceType = response[0].announce_type
            this.announceDate = response[0].publicDate;

          } else if (response[0].announce_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail_en
            this.showAnnounce = response
            this.pdfUrl = this.urlTransform(response[0].detail_en)
            this.announceTitle = response[0].title_en
            this.announceType = response[0].announce_type
            this.filesize = response[0].filesize
            this.announceDate = response[0].publicDate;
          }
          else if (response[0].announce_type === 'vdo') {
            this.file_pdf = 'no'
            this.showAnnounce = response
            this.id = response[0].detail_en
            this.announceTitle = response[0].title_en
            this.announceType = response[0].announce_type
            this.announceDate = response[0].publicDate;

          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,

        })
      })
    })
  }


  ngOnDestroy() {
    this.announce.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}